import ItemsCollection, { Item } from './ItemsCollection';

import Module from './Module';
import axiosInstance from '@/helpers/axios';
import {generateLog} from '@/helpers/functions';

export class TranscoderStreamItem extends Item implements ITranscoderStream {

  id!: number | null;
  name!: string;
  hardware!: ITranscoderStreamHardware;
  in!: ITranscoderStreamIn;
  out!: ITranscoderStreamOut[];
  slug!: string;
  active!: boolean;
  log!: any[];

}

export class TranscoderStreamsCollection extends ItemsCollection<TranscoderStreamItem> {
  model() {
    return TranscoderStreamItem;
  }

  url(): string {
    return this.module.url();
  }
}

export default class StreamModule extends Module<TranscoderStreamsCollection> {

  url() {
    return `/transcoder/${this.id}/streams`;
  }

  getStreams() {
    return axiosInstance.get(this.url())
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Streams',
          message: e,
        };
        generateLog(log);
      });
  }

  getSelectedStream(id: number) {
    return axiosInstance.get(`${this.url()}/${id}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Streams',
          message: e,
        };
        generateLog(log);
      });
  }

  search(input: string, page: number, source: any) {
    return axiosInstance.get(`${this.url()}?query=${input}&page=${page}`, {cancelToken: source.token})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Streams',
          message: e,
        };
        generateLog(log);
      });
  }

  deleteStream(id: number) {
    return axiosInstance.delete(`${this.url()}/${id}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Streams',
          message: e,
        };
        generateLog(log);
      });
  }

  createStream(stream: ITranscoderStream) {
    return axiosInstance.post(`${this.url()}`, stream)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Streams',
          message: e,
        };
        generateLog(log);
      });
  }

  saveEditedStream(stream: ITranscoderStream) {
    return axiosInstance.put(`${this.url()}/${stream.id}`, stream)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Streams',
          message: e,
        };
        generateLog(log);
      });
  }

  getStreamsOnPage(index: number) {
    return axiosInstance.get(`${this.url()}?page=${index}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Streams',
          message: e,
        };
        generateLog(log);
      });
  }
}
